import { render, staticRenderFns } from "./SeletorFiltro.vue?vue&type=template&id=70fe1b7b&scoped=true&lang=pug&"
import script from "./SeletorFiltro.vue?vue&type=script&lang=js&"
export * from "./SeletorFiltro.vue?vue&type=script&lang=js&"
import style0 from "./SeletorFiltro.vue?vue&type=style&index=0&id=70fe1b7b&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fe1b7b",
  null
  
)

export default component.exports